<script lang="ts" setup>
import { ref, inject } from "vue";
import Config from "@/config/Config";

interface Props {
  toolTipKey: string;
}

const props = defineProps<Props>();
const link = ref(Config.links.help);

if (props.toolTipKey && Config.links[props.toolTipKey as keyof typeof Config.links]) {
  link.value = `${Config.links.help}/${Config.links[props.toolTipKey as keyof typeof Config.links]}`;
}

</script>
<template>
  <div class="ml-4">
    <a :href="link" target="_blank" class="text-action text-lg ">
      <i class="far fa-circle-question"></i>
    </a>
  </div>
</template>
